BatchGeoStore.addReducer("BatchGeoTableMap", function (state, action) {
  state = state || {
    mapHeights: {
      mapWrap: 0,
      mapDiv: 0,
      tableScroller: 0,
    },
    visibility: null,
    shouldForceRenderTable: false,
    isTableSelectable: false,
  };

  switch (action.type) {
    case "TABLE_MAP_UPDATE_HEIGHTS":
      return Object.assign({}, state, {
        mapHeights: action.mapHeights,
      });

    case "TABLE_MAP_VISIBILITY":
      return Object.assign({}, state, {
        visibility: action.visibility,
        shouldForceRenderTable:
          typeof action.shouldForceRenderTable !== "undefined"
            ? action.shouldForceRenderTable
            : state.shouldForceRenderTable,
      });

    case "TABLE_MAP_VISIBILITY_TOGGLE":
      return Object.assign({}, state, {
        visibility: !state.visibility,
      });

    case "TABLE_MAP_SELECTABLE":
      return Object.assign({}, state, {
        isTableSelectable: action.isTableSelectable,
      });

    default:
      return state;
  }
});
